import React from 'react';

interface SafeHtmlRendererProps {
  html: string;
  className?: string;
}

export const SafeHtmlRenderer: React.FC<SafeHtmlRendererProps> = ({
  html,
  className = ''
}) => {
  if (!html) {
    return null;
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default SafeHtmlRenderer;